import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import modules from '@/store/modules'

Vue.use(Vuex)

const vuexPersistent = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth', 'snapshots', 'selectedAssistant', 'workspaces', 'wordcloud']
})

export default new Vuex.Store({
  strict: true,
  state: {},
  modules,
  plugins: [vuexPersistent.plugin]
})
